import { CalendarCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { COACHING_IMAGES, COACHING_LINKS } from "@/data/coaching";

export const CoachingCta = () => (
  <section data-testid="coaching-cta-section" className="bg-navy text-white">
    <div className="grid items-center lg:grid-cols-[1fr_0.7fr]">
        <div className="px-5 py-14 sm:px-8 sm:py-20 lg:pr-12 lg:pl-[max(2rem,calc((100vw-72rem)/2+2rem))]">
          <h2 className="font-heading text-3xl font-bold tracking-tight sm:text-4xl">Not Sure Where to Start?</h2>
          <p className="mt-4 font-heading text-lg font-semibold sm:text-xl text-white/90">Still unsure which path is right for you?</p>
          <p className="mt-5 max-w-lg text-base leading-relaxed text-white/75">
            No worries. Pull up a chair to my virtual desk. We'll talk through what's holding you back and how we'll move you forward.
          </p>
          <Button asChild data-testid="coaching-final-cta" className="bg-white text-navy hover:bg-mist active:scale-95 mt-8 h-13 px-7 text-base">
            <a href={COACHING_LINKS.calendly} target="_blank" rel="noopener noreferrer"><CalendarCheck className="mr-2 h-5 w-5" /> Let's talk it out</a>
          </Button>
        </div>
        <img src={COACHING_IMAGES.unsure} alt="Confident woman leader in a modern office" className="hidden h-full w-full object-cover lg:block" />
    </div>
  </section>
);
